import { render, staticRenderFns } from "./TextWithLabel.vue?vue&type=template&id=79b7e15d&"
import script from "./TextWithLabel.vue?vue&type=script&lang=js&"
export * from "./TextWithLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports